import { Checkbox } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import AmazonAsinIds from "./AsinUpdate"

const UPDATEFIELDS = ['deleted', 'gender']

const CuratorVideoDataUpdate = () => {
  const { id } = useParams()


  const [videoData, setVideoData] = useState({})
  const [dataToUpdate, setDataToUpdate] = useState({})
  const [loading, setLoading] = useState(false)
  const [updateDocument, setUpdateDocument] = useState({})

  const getVideoData = async () => {
    const response = await axios.get(`/images-meta-api/videos/video?id=${id}`)
    setVideoData(response.data.video)
  }

  useEffect(() => {
    setDataToUpdate({ ...videoData })
  }, [videoData])

  useEffect(() => {
    const keys = Object.keys(dataToUpdate)

    const newUpdateDocument = {}
    keys.forEach(k => {
      if (JSON.stringify(dataToUpdate[k], null, 0) != JSON.stringify(videoData[k], null, 0)) {
        newUpdateDocument[k] = dataToUpdate[k]
      }
    })
    setUpdateDocument(newUpdateDocument)

  }, [dataToUpdate])



  const updateVideoData = async () => {
    setLoading(true)
    const response = await axios.post(`/images-meta-api/videos/video?id=${id}`, { dataToUpdate: updateDocument })
    await getVideoData()
    setLoading(false)
  }

  useEffect(() => {
    getVideoData()
  }, [id])

  return <div>
    {videoData && videoData._id ? <div className="flex w-full py-4">
      <div className="w-full lg:w-1/3 shrink-0 px-4">
        <video src={videoData.imageUrl} controls />
      </div>
      <div className="w-full lg:w-2/3 shrink-0 min-h-full p-2">
        <div className=" rounded border border-slate-100 min-h-full p-2">
          <div>
            <h3 className="w-full text-center text-xl ">Filled Data</h3>
            {videoData.deleted ? <span className="bg-red-500 text-white p-1 ">DELETED</span> : null}
            <div>Gender : {videoData.gender}</div>

          </div>
          <div className="flex justify-center my-4">
            <hr className="border border-slate-300 w-1/2" />
          </div>
          <div>
            <h3 className="w-full text-center text-xl ">Data To Update</h3>
            <div>
              Deleted: <Checkbox checked={dataToUpdate.hasOwnProperty('deleted') ? dataToUpdate.deleted : (videoData.deleted ? true : false)} onClick={e => {
                setDataToUpdate(prev => {
                  prev.deleted = dataToUpdate.hasOwnProperty('deleted') ? !dataToUpdate.deleted : (videoData.deleted ? false : true)
                  return { ...prev }
                })
              }} />
            </div>

            <div className="flex">

              {['M', 'F'].map(g => <div>
                <Checkbox
                  checked={dataToUpdate.gender == g}
                  onClick={e => {
                    setDataToUpdate(prev => {
                      prev.gender = g
                      return { ...prev }
                    })
                  }}
                /> {g}
              </div>)}
            </div>
            {dataToUpdate.gender ? <div>


            </div> : null}

            <div className="flex justify-center">
              <button
                className="min-w-1/3 text-center rounded-full bg-slate-700 text-white p-2 font-semibold px-6 disabled:bg-slate-500 "
                onClick={updateVideoData}
                disabled={loading || !dataToUpdate || Object.keys(dataToUpdate).length == 0}
              >Update Data</button>
            </div>
          </div>
          {videoData.gender ? <AmazonAsinIds crossSell={videoData.crossSell} valueToUpdate={updateDocument} setValuesToUpdate={setUpdateDocument} isDataLoading={loading} gender={videoData.gender} updateVideoData={getVideoData} videoId={id} /> : null}
        </div>


      </div>

    </div> : <div><h3 className="w-full text-center pt-20">Request Failed</h3></div>}
  </div>
}

export default CuratorVideoDataUpdate
